import script from "./View-Product.vue?vue&type=script&setup=true&lang=js"
export * from "./View-Product.vue?vue&type=script&setup=true&lang=js"

import "./View-Product.vue?vue&type=style&index=0&id=ec63d490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec63d490"]])

export default __exports__